<template>
  <component
    :is="'payback-' + mappedType"
    :added="added"
    :product="product"
  ></component>
</template>

<script>
import PaybackFixKupon from './PaybackFixKupon'
import PaybackExpress from './PaybackExpress'
import PaybackReverse from './PaybackReverse'
import PaybackReverseProtect from './PaybackReverseProtect'
import PaybackMemoryExpress from './PaybackMemoryExpress'

export default {
  name: 'payback-text-container',
  data() {
    return {
      typeMap: {
        QTE0: 'express',
        QTEF: 'fix-kupon',
        QTEM: 'memory-express',
        QTR0: 'reverse',
        QTRP: 'reverse-protect',
      }
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    added: {
      type: Object,
      required: true
    }
  },
  computed: {
    mappedType() {
      return this.typeMap[this.product.type]
    }
  },
  components: {
    PaybackFixKupon,
    PaybackExpress,
    PaybackReverse,
    PaybackReverseProtect,
    PaybackMemoryExpress
  }
}
</script>



// WEBPACK FOOTER //
// PaybackTextContainer.vue?64633f86